



























import { Component, Mixins, Vue } from "vue-property-decorator";
import SettingMixin from "@/mixins/settingMixin";
import { getState } from "@/apis";

import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";
import ExpansionPanels from "@/components/ExpansionPanels.vue";
import { URL_PARAM_STATE } from "@/utils/url";

@Component({
  components: {
    ContainImage,
    ExpansionPanels,
    ImageButton,
  },
})
export default class Expired extends Mixins(Vue, SettingMixin) {
  async mounted(): Promise<void> {
    await getState(this.campaignId)
      .then(async (res) => {
        // 応募画面 期間外画面
        if (res.data.state === "open") {
          this.routerPushCampaignPage();
          return;
        }
      })
      .catch(() => {
        this.routerPushSystemErrorPage();
      });
  }

  get state(): string {
    return this.$route.query[URL_PARAM_STATE] as string;
  }

  getImageName(): string {
    if (this.state === "teaser")
      return this.config.imageName.expiredPage.teaser + "";
    if (this.state === "closed")
      return this.config.imageName.expiredPage.closed + "";
    return "";
  }
}
